import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CardLinkOfferCategory } from './models/card-link-offer-category.model';

export interface CardLinkOfferCategoriesState extends EntityState<CardLinkOfferCategory> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'card-link-offer-categories', idKey: 'TagId' })
export class CardLinkOfferCategoriesStore extends EntityStore<CardLinkOfferCategoriesState> {

  constructor() {
    super();
  }

}
